(function () {
  'use strict';

  function normalize(value) { return String(value == null ? '' : value).trim().toLowerCase().replace(/\s+/g, ' '); }
  function numberFrom(value) { var match = String(value == null ? '' : value).match(/\d+(?:\.\d+)?/); return match ? Number(match[0]) : 0; }
  function parseDimensions(value) {
    var match = String(value == null ? '' : value).match(/(\d+(?:\.\d+)?)\s*(?:in)?\s*[x×]\s*(\d+(?:\.\d+)?)/i);
    if (!match) return null;
    return { width: Number(match[1]), height: Number(match[2]), label: match[1] + ' × ' + match[2] + ' in' };
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    var value = Number(number || 0) / 100;
    var parts = value.toFixed(precision).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.join(decimal);
  }
  function formatMoney(cents, format) {
    var template = format || '${{amount}}';
    var placeholder = template.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!placeholder) return '$' + formatWithDelimiters(cents, 2, ',', '.');
    var value;
    switch (placeholder[1]) {
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2, ',', '.');
    }
    return template.replace(placeholder[0], value);
  }
  function clamp(value, min, max) { return Math.min(max, Math.max(min, value)); }
  function setText(root, selector, value) { var node = root.querySelector(selector); if (node) node.textContent = value; }

  function init(root) {
    if (!root || root.getAttribute('data-far-car-v4-initialized') === 'true') return;
    var dataNode = root.querySelector('[data-far-car-v4-product-data]');
    var form = root.querySelector('.far-car-v4__form');
    if (!dataNode || !form) return;

    var data;
    try { data = JSON.parse(dataNode.textContent || '{}'); }
    catch (error) { console.error('FAR Car Magnets v4.5 product data error:', error); return; }
    root.setAttribute('data-far-car-v4-initialized', 'true');

    var variants = Array.isArray(data.variants) ? data.variants : [];
    var productOptions = Array.isArray(data.options) ? data.options : [];

    var artworkInput = root.querySelector('[data-far-car-v4-artwork]');
    var artworkPreview = root.querySelector('[data-far-car-v4-artwork-preview]');
    var placeholder = root.querySelector('[data-far-car-v4-placeholder]');
    var fileCard = root.querySelector('[data-far-car-v4-file-card]');
    var fileType = root.querySelector('[data-far-car-v4-file-type]');
    var fileName = root.querySelector('[data-far-car-v4-file-name]');
    var uploadTitle = root.querySelector('[data-far-car-v4-upload-title]');
    var uploadStatus = root.querySelector('[data-far-car-v4-upload-status]');
    var previewStatus = root.querySelector('[data-far-car-v4-preview-status]');
    var sceneImage = root.querySelector('[data-far-car-v4-scene-image]');
    var vehiclePlaceholder = root.querySelector('[data-far-car-v4-vehicle-placeholder]');
    var editor = root.querySelector('[data-far-car-v4-editor]');
    var magnet = root.querySelector('[data-far-car-v4-magnet]');
    var scaleInput = root.querySelector('[data-far-car-v4-scale]');
    var centerButton = root.querySelector('[data-far-car-v4-center]');
    var resetButton = root.querySelector('[data-far-car-v4-reset]');
    var customVehicleInput = root.querySelector('[data-far-car-v4-vehicle-photo]');
    var customVehicleStatus = root.querySelector('[data-far-car-v4-vehicle-photo-status]');
    var vehicleUploadTitle = root.querySelector('[data-far-car-v4-vehicle-upload-title]');
    var sceneChoices = root.querySelectorAll('[data-far-car-v4-scene-choice]');
    var customPhotoPanel = root.querySelector('[data-far-car-v4-custom-photo-panel]');
    var vehicleProperty = root.querySelector('[data-far-car-v4-vehicle-property]');
    var placementProperty = root.querySelector('[data-far-car-v4-placement-property]');
    var summaryPlacement = root.querySelector('[data-far-car-v4-summary-placement]');
    var submitButton = root.querySelector('[data-far-car-v4-submit]');
    var variantInput = root.querySelector('[data-far-car-v4-variant-id]');
    var positionXProperty = root.querySelector('[data-far-car-v4-position-x-property]');
    var positionYProperty = root.querySelector('[data-far-car-v4-position-y-property]');
    var visualScaleProperty = root.querySelector('[data-far-car-v4-visual-scale-property]');
    var sizeProperty = root.querySelector('[data-far-car-v4-size-property]');
    var quantityProperty = root.querySelector('[data-far-car-v4-quantity-property]');
    var artworkNameProperty = root.querySelector('[data-far-car-v4-artwork-name-property]');
    var aspectProperty = root.querySelector('[data-far-car-v4-aspect-property]');
    var customPhotoProperty = root.querySelector('[data-far-car-v4-custom-photo-property]');
    var vehiclePhotoNameProperty = root.querySelector('[data-far-car-v4-vehicle-photo-name-property]');
    var formStatus = root.querySelector('[data-far-car-v4-form-status]');
    var cartPreviewInput = root.querySelector('[data-far-car-v4-cart-preview]');

    var artworkReady = Boolean(artworkInput && artworkInput.files && artworkInput.files[0]);
    var vehicleReady = true;
    var fileError = '';
    var state = { x: 50, y: 50, scale: 100 };
    var currentSceneKey = 'van-side';
    var customVehicleSource = ''; 
    var interaction = null;
    var previewPrepared = false;
    var previewPreparing = false;

    function groupValue(group) {
      if (!group) return '';
      var select = group.querySelector('[data-far-car-v4-option-select]');
      if (select) return select.value;
      var radio = group.querySelector('[data-far-car-v4-option]:checked');
      return radio ? radio.value : '';
    }
    function selectedValues() {
      var values = [];
      for (var index = 0; index < productOptions.length; index += 1) {
        var group = root.querySelector('[data-far-car-v4-option-group][data-option-index="' + index + '"]');
        values[index] = groupValue(group);
      }
      return values;
    }
    function selectedValueAt(index) {
      if (index < 0) return '';
      var group = root.querySelector('[data-far-car-v4-option-group][data-option-index="' + index + '"]');
      return groupValue(group);
    }
    function exactVariant(values) {
      if (!values.length || values.some(function (value) { return !value; })) return null;
      return variants.find(function (variant) {
        if (!variant || !Array.isArray(variant.options) || variant.options.length !== values.length) return false;
        return variant.options.every(function (optionValue, index) { return normalize(optionValue) === normalize(values[index]); });
      }) || null;
    }
    function selectedSize() { return selectedValueAt(Number(data.size_option_index)); }
    function selectedQuantity() { return selectedValueAt(Number(data.quantity_option_index)); }
    function quantityNumber() { return numberFrom(selectedQuantity()) || 1; }

    function variantForQuantity(quantityValue) {
      var values = selectedValues();
      var quantityIndex = Number(data.quantity_option_index);
      if (quantityIndex < 0 || quantityIndex >= values.length) return null;
      values[quantityIndex] = String(quantityValue);
      return exactVariant(values);
    }

    function discountPercent(variant) {
      if (!variant || !variant.compare_at_price || variant.compare_at_price <= variant.price) return 0;
      return Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
    }

    function updateQuantityCards() {
      root.querySelectorAll('[data-far-car-v4-quantity-card]').forEach(function (card) {
        var quantity = numberFrom(card.getAttribute('data-quantity-value')) || 1;
        var variant = variantForQuantity(quantity);
        var unitNode = card.querySelector('[data-far-car-v4-quantity-unit]');
        var totalNode = card.querySelector('[data-far-car-v4-quantity-total]');
        var saveNode = card.querySelector('[data-far-car-v4-quantity-save]');
        var discount = discountPercent(variant);
        if (unitNode) unitNode.textContent = variant ? formatMoney(Math.round(variant.price / quantity), data.money_format) + ' each' : 'Unavailable';
        if (totalNode) totalNode.textContent = variant ? formatMoney(variant.price, data.money_format) + ' total' : '';
        if (saveNode) {
          saveNode.hidden = discount <= 0;
          saveNode.textContent = discount > 0 ? 'SAVE ' + discount + '%' : '';
        }
        card.classList.toggle('is-unavailable', !variant || !variant.available);
      });
    }

    function baseGeometry() {
      var dimensions = parseDimensions(selectedSize()) || { width: 18, height: 12 };
      var ratio = dimensions.width / dimensions.height;
      var baseWidth = Math.min(320, Math.max(120, (editor ? editor.clientWidth : 800) * 0.24));
      var baseHeight = baseWidth / ratio;
      var maxHeight = (editor ? editor.clientHeight : 600) * 0.35;
      if (baseHeight > maxHeight) { baseHeight = maxHeight; baseWidth = baseHeight * ratio; }
      return { width: baseWidth, height: baseHeight, ratio: ratio };
    }
    function halfPercent() {
      if (!magnet || !editor || !editor.clientWidth || !editor.clientHeight) return { x: 0, y: 0 };
      return { x: (magnet.offsetWidth / editor.clientWidth) * 50, y: (magnet.offsetHeight / editor.clientHeight) * 50 };
    }
    function applyPosition() {
      if (!magnet) return;
      var half = halfPercent();
      state.x = clamp(state.x, half.x, 100 - half.x);
      state.y = clamp(state.y, half.y, 100 - half.y);
      magnet.style.setProperty('left', state.x.toFixed(2) + '%', 'important');
      magnet.style.setProperty('top', state.y.toFixed(2) + '%', 'important');
      magnet.style.setProperty('right', 'auto', 'important');
      magnet.style.setProperty('bottom', 'auto', 'important');
      magnet.style.setProperty('transform', 'translate(-50%, -50%)', 'important');
      if (positionXProperty) positionXProperty.value = state.x.toFixed(1) + '%';
      if (positionYProperty) positionYProperty.value = state.y.toFixed(1) + '%';
      previewPrepared = false;
    }
    function applyGeometry() {
      if (!magnet || !editor) return;
      var base = baseGeometry();
      var width = base.width * (state.scale / 100);
      var height = base.height * (state.scale / 100);
      var maxWidth = Math.max(64, editor.clientWidth * 0.94);
      var maxHeight = Math.max(44, editor.clientHeight * 0.88);
      if (width > maxWidth) { state.scale *= maxWidth / width; width = maxWidth; height = width / base.ratio; }
      if (height > maxHeight) { state.scale *= maxHeight / height; height = maxHeight; width = height * base.ratio; }
      width = Math.max(52, width); height = Math.max(36, height);
      magnet.style.width = width.toFixed(2) + 'px';
      magnet.style.height = height.toFixed(2) + 'px';
      if (scaleInput) scaleInput.value = String(Math.round(state.scale));
      setText(root, '[data-far-car-v4-scale-value]', Math.round(state.scale) + '%');
      setText(root, '[data-far-car-v4-meta-scale]', Math.round(state.scale) + '%');
      if (visualScaleProperty) visualScaleProperty.value = Math.round(state.scale) + '%';
      applyPosition();
    }
    function centerPreview(resetScale) {
      state.x = 50; state.y = 50;
      if (resetScale) state.scale = 100;
      applyGeometry();
    }
    function scheduleCenter(resetScale) {
      centerPreview(resetScale);
      window.requestAnimationFrame(function () {
        centerPreview(resetScale);
        window.requestAnimationFrame(function () { centerPreview(resetScale); });
      });
    }
    function setScale(value) { state.scale = clamp(Number(value) || 100, 35, 240); applyGeometry(); }

    function updateSizeSwatches() {
      root.querySelectorAll('[data-far-car-v4-size-shape]').forEach(function (shape) {
        var dimensions = parseDimensions(shape.getAttribute('data-size-value'));
        if (!dimensions) return;
        var scale = Math.min(42 / dimensions.width, 25 / dimensions.height);
        shape.style.width = Math.max(12, dimensions.width * scale) + 'px';
        shape.style.height = Math.max(10, dimensions.height * scale) + 'px';
      });
    }

    function sceneFor(key) {
      return (Array.isArray(data.scenes) ? data.scenes : []).find(function (scene) { return scene && scene.key === key; }) || null;
    }
    function setSceneImage(source, label) {
      if (!sceneImage) return;
      if (!source) {
        sceneImage.removeAttribute('src');
        sceneImage.classList.add('is-empty');
        sceneImage.alt = 'Upload your vehicle photo';
        if (vehiclePlaceholder) vehiclePlaceholder.classList.remove('is-hidden');
        return;
      }
      sceneImage.classList.add('is-loading');
      sceneImage.alt = label || 'Centered vehicle preview';
      sceneImage.onload = function () {
        sceneImage.classList.remove('is-loading', 'is-empty');
      };
      sceneImage.onerror = function () {
        sceneImage.classList.remove('is-loading');
        sceneImage.classList.add('is-empty');
        if (vehiclePlaceholder) vehiclePlaceholder.classList.remove('is-hidden');
      };
      sceneImage.src = source;
      if (sceneImage.complete && sceneImage.naturalWidth > 0) {
        sceneImage.classList.remove('is-loading', 'is-empty');
      }
      if (vehiclePlaceholder) vehiclePlaceholder.classList.add('is-hidden');
      previewPrepared = false;
    }
    function updateSceneLabels(scene) {
      var label = scene && scene.label ? scene.label : 'My vehicle';
      if (vehicleProperty) vehicleProperty.value = scene && scene.vehicle ? scene.vehicle : 'My vehicle';
      if (placementProperty) placementProperty.value = label;
      if (summaryPlacement) summaryPlacement.textContent = label + ' preview';
      setText(root, '[data-far-car-v4-meta-photo]', label);
    }
    function applyScene(key, resetEditor) {
      currentSceneKey = key || 'van-side';
      var scene = sceneFor(currentSceneKey) || sceneFor('van-side');
      var isCustom = currentSceneKey === 'custom-photo';
      if (customPhotoPanel) customPhotoPanel.classList.toggle('is-hidden', !isCustom);
      if (isCustom) {
        vehicleReady = Boolean(customVehicleSource);
        setSceneImage(customVehicleSource, 'Centered customer vehicle photo preview');
        updateSceneLabels({vehicle:'My vehicle',label:'My vehicle'});
      } else {
        vehicleReady = true;
        setSceneImage(scene && scene.image, scene && scene.label ? scene.label : 'Flat van preview');
        updateSceneLabels(scene);
        if (customPhotoProperty) customPhotoProperty.value = 'No';
      }
      if (resetEditor) scheduleCenter(true);
      updateVariant();
    }

    function updatePreviewStatus() {
      if (!previewStatus) return;
      previewStatus.classList.toggle('is-ready', artworkReady && vehicleReady);
      if (artworkReady && vehicleReady) previewStatus.textContent = 'Preview ready';
      else if (!vehicleReady) previewStatus.textContent = 'Add vehicle photo';
      else previewStatus.textContent = 'Add artwork';
    }

    function updateVariant() {
      var values = selectedValues();
      var match = exactVariant(values);
      var quantity = quantityNumber();
      var price = match ? formatMoney(match.price, data.money_format) : 'Unavailable';
      var unitPrice = match && quantity ? formatMoney(Math.round(match.price / quantity), data.money_format) + ' each' : '';
      var dimensions = parseDimensions(selectedSize());
      var sizeLabel = dimensions ? dimensions.label : (selectedSize() || 'Select size');
      var quantityLabel = quantity + (quantity === 1 ? ' magnet' : ' magnets');
      setText(root, '[data-far-car-v4-price]', price);
      setText(root, '[data-far-car-v4-submit-price]', price);
      setText(root, '[data-far-car-v4-unit-price]', unitPrice);
      setText(root, '[data-far-car-v4-summary]', sizeLabel + ' / ' + quantityLabel);
      var selectedDiscount = discountPercent(match);
      setText(root, '[data-far-car-v4-summary-savings]', selectedDiscount > 0 ? 'SAVE ' + selectedDiscount + '% · ' + unitPrice : (unitPrice || ''));
      setText(root, '[data-far-car-v4-meta-size]', sizeLabel);
      updateQuantityCards();
      var currentScene = sceneFor(currentSceneKey);
      setText(root, '[data-far-car-v4-preview-title]', (currentSceneKey === 'custom-photo' ? 'My vehicle' : (currentScene && currentScene.label ? currentScene.label : 'Van side')) + ' / ' + sizeLabel);
      if (variantInput) variantInput.value = match ? match.id : '';
      if (quantityProperty) quantityProperty.value = String(quantity);
      if (sizeProperty) sizeProperty.value = sizeLabel;
      var canSubmit = Boolean(match && match.available && artworkReady && !fileError);
      if (submitButton) submitButton.disabled = !canSubmit;
      if (formStatus) {
        formStatus.classList.remove('is-ready', 'is-error');
        if (fileError) { formStatus.textContent = fileError; formStatus.classList.add('is-error'); }
        else if (!artworkReady) formStatus.textContent = 'Upload artwork to continue.';
        else if (!match) formStatus.textContent = 'Choose an available size and quantity.';
        else if (!match.available) formStatus.textContent = 'The selected variant is unavailable.';
        else {
          formStatus.textContent = sizeLabel + ' / ' + quantityLabel + ' is ready to add.' + (vehicleReady ? '' : ' Vehicle photo is optional for checkout.');
          formStatus.classList.add('is-ready');
        }
      }
      applyGeometry();
      updatePreviewStatus();
    }

    function resetArtworkDisplay() {
      artworkReady = false; fileError = ''; previewPrepared = false;
      if (artworkPreview) { artworkPreview.removeAttribute('src'); artworkPreview.classList.add('is-hidden'); artworkPreview.hidden = true; }
      if (placeholder) placeholder.classList.remove('is-hidden');
      if (fileCard) fileCard.classList.add('is-hidden');
      if (uploadTitle) uploadTitle.textContent = 'Choose artwork';
      if (uploadStatus) uploadStatus.textContent = 'No file selected';
      if (artworkNameProperty) artworkNameProperty.value = '';
      if (aspectProperty) aspectProperty.value = '';
    }
    function showFileCard(file) {
      if (placeholder) placeholder.classList.add('is-hidden');
      if (artworkPreview) { artworkPreview.classList.add('is-hidden'); artworkPreview.hidden = true; }
      if (fileCard) fileCard.classList.remove('is-hidden');
      if (fileType) fileType.textContent = file.name.indexOf('.') >= 0 ? file.name.split('.').pop().toUpperCase() : 'FILE';
      if (fileName) fileName.textContent = file.name;
    }
    function loadArtwork(file) {
      resetArtworkDisplay();
      if (!file) { updateVariant(); return; }
      var max = Number(data.max_file_size_mb || 20) * 1024 * 1024;
      if (file.size > max) {
        fileError = 'The artwork file exceeds the ' + Number(data.max_file_size_mb || 20) + ' MB limit.';
        if (artworkInput) artworkInput.value = '';
        if (uploadStatus) uploadStatus.textContent = fileError;
        updateVariant(); return;
      }
      artworkReady = true;
      if (artworkNameProperty) artworkNameProperty.value = file.name;
      if (uploadTitle) uploadTitle.textContent = 'Replace artwork';
      if (uploadStatus) uploadStatus.textContent = file.name;
      if (/^image\/(png|jpe?g|webp|gif)$/i.test(file.type)) {
        var reader = new FileReader();
        reader.onload = function (event) {
          var image = new Image();
          image.onload = function () {
            if (aspectProperty && image.naturalWidth && image.naturalHeight) aspectProperty.value = image.naturalWidth + ':' + image.naturalHeight;
            if (artworkPreview) { artworkPreview.src = String(event.target.result || ''); artworkPreview.classList.remove('is-hidden'); artworkPreview.hidden = false; }
            if (placeholder) placeholder.classList.add('is-hidden');
            if (fileCard) fileCard.classList.add('is-hidden');
            scheduleCenter(true);
            updateVariant();
          };
          image.onerror = function () { showFileCard(file); updateVariant(); };
          image.src = String(event.target.result || '');
        };
        reader.onerror = function () { fileError = 'The artwork file could not be read in this browser.'; showFileCard(file); updateVariant(); };
        reader.readAsDataURL(file);
      } else { showFileCard(file); scheduleCenter(true); updateVariant(); }
    }

    function loadCustomVehiclePhoto(file) {
      if (!file) return;
      if (!/^image\/(png|jpe?g|webp)$/i.test(file.type)) {
        if (customVehicleStatus) customVehicleStatus.textContent = 'Choose a PNG, JPG, or WEBP vehicle photo.';
        return;
      }
      var reader = new FileReader();
      reader.onload = function (event) {
        var source = String(event.target.result || '');
        var probe = new Image();
        probe.onload = function () {
          vehicleReady = true;
          customVehicleSource = source;
          currentSceneKey = 'custom-photo';
          sceneChoices.forEach(function (choice) { choice.checked = choice.value === 'custom-photo'; });
          if (customPhotoPanel) customPhotoPanel.classList.remove('is-hidden');
          setSceneImage(source, 'Centered customer vehicle photo preview');
          if (customVehicleStatus) customVehicleStatus.textContent = file.name;
          if (vehicleUploadTitle) vehicleUploadTitle.textContent = 'Replace vehicle photo';
          if (customPhotoProperty) customPhotoProperty.value = 'Yes';
          if (vehiclePhotoNameProperty) vehiclePhotoNameProperty.value = file.name;
          updateSceneLabels({vehicle:'My vehicle',label:'My vehicle'});
          scheduleCenter(true);
          updateVariant();
        };
        probe.onerror = function () { if (customVehicleStatus) customVehicleStatus.textContent = 'The vehicle photo could not be displayed.'; };
        probe.src = source;
      };
      reader.onerror = function () { if (customVehicleStatus) customVehicleStatus.textContent = 'The vehicle photo could not be read.'; };
      reader.readAsDataURL(file);
    }

    function loadDrawable(source) {
      return new Promise(function (resolve, reject) {
        if (!source) { reject(new Error('Image source is unavailable.')); return; }
        function loadFromUrl(url, revoke) {
          var image = new Image();
          image.decoding = 'async';
          image.onload = function () { if (revoke) URL.revokeObjectURL(url); resolve(image); };
          image.onerror = function () { if (revoke) URL.revokeObjectURL(url); reject(new Error('Image could not be loaded.')); };
          image.src = url;
        }
        if (/^(data:|blob:)/i.test(source)) { loadFromUrl(source, false); return; }
        fetch(source, { mode: 'cors', credentials: 'omit' })
          .then(function (response) { if (!response.ok) throw new Error('Image request failed.'); return response.blob(); })
          .then(function (blob) { loadFromUrl(URL.createObjectURL(blob), true); })
          .catch(reject);
      });
    }

    function containedRect(sourceWidth, sourceHeight, box) {
      var safeWidth = Math.max(1, Number(sourceWidth) || 1);
      var safeHeight = Math.max(1, Number(sourceHeight) || 1);
      var scale = Math.min(box.width / safeWidth, box.height / safeHeight);
      var width = safeWidth * scale;
      var height = safeHeight * scale;
      return { x: box.x + (box.width - width) / 2, y: box.y + (box.height - height) / 2, width: width, height: height };
    }

    function drawContained(context, image, box) {
      var width = image.naturalWidth || image.width || 1;
      var height = image.naturalHeight || image.height || 1;
      var target = containedRect(width, height, box);
      context.drawImage(image, target.x, target.y, target.width, target.height);
    }

    function canvasBlob(canvas) {
      return new Promise(function (resolve, reject) {
        canvas.toBlob(function (blob) { if (blob) resolve(blob); else reject(new Error('Preview image could not be encoded.')); }, 'image/png');
      });
    }

    function assignPreviewFile(file) {
      if (!cartPreviewInput || typeof DataTransfer === 'undefined') throw new Error('This browser cannot attach the cart preview.');
      var transfer = new DataTransfer();
      transfer.items.add(file);
      cartPreviewInput.files = transfer.files;
    }

    async function generateCartPreview() {
      if (!editor || !magnet || !artworkReady) throw new Error('Upload artwork before adding the item.');
      var editorRect = editor.getBoundingClientRect();
      var magnetRect = magnet.getBoundingClientRect();
      if (!editorRect.width || !editorRect.height || !magnetRect.width || !magnetRect.height) throw new Error('The live preview is not ready yet.');

      var canvasWidth = 1200;
      var canvasHeight = Math.round(canvasWidth * (editorRect.height / editorRect.width));
      if (canvasHeight > 1200) { canvasWidth = Math.round(1200 * (editorRect.width / editorRect.height)); canvasHeight = 1200; }
      canvasWidth = Math.max(720, canvasWidth);
      canvasHeight = Math.max(520, canvasHeight);
      var scaleX = canvasWidth / editorRect.width;
      var scaleY = canvasHeight / editorRect.height;
      var canvas = document.createElement('canvas');
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      var context = canvas.getContext('2d', { alpha: false });
      if (!context) throw new Error('The preview canvas is unavailable.');
      context.fillStyle = '#eef3f7';
      context.fillRect(0, 0, canvasWidth, canvasHeight);

      if (sceneImage && sceneImage.currentSrc && !sceneImage.classList.contains('is-empty')) {
        try {
          var sceneDrawable = await loadDrawable(sceneImage.currentSrc || sceneImage.src);
          var sceneElementRect = sceneImage.getBoundingClientRect();
          drawContained(context, sceneDrawable, {
            x: (sceneElementRect.left - editorRect.left) * scaleX,
            y: (sceneElementRect.top - editorRect.top) * scaleY,
            width: sceneElementRect.width * scaleX,
            height: sceneElementRect.height * scaleY
          });
        } catch (sceneError) {
          /* Keep a neutral background if a remote preview image cannot be exported safely. */
        }
      }

      var artBox = {
        x: (magnetRect.left - editorRect.left) * scaleX,
        y: (magnetRect.top - editorRect.top) * scaleY,
        width: magnetRect.width * scaleX,
        height: magnetRect.height * scaleY
      };

      if (artworkPreview && artworkPreview.currentSrc && !artworkPreview.classList.contains('is-hidden')) {
        var artworkDrawable = await loadDrawable(artworkPreview.currentSrc || artworkPreview.src);
        drawContained(context, artworkDrawable, artBox);
      } else {
        context.save();
        context.fillStyle = 'rgba(255,255,255,0.92)';
        context.fillRect(artBox.x, artBox.y, artBox.width, artBox.height);
        context.strokeStyle = '#07285d';
        context.lineWidth = Math.max(2, canvasWidth / 500);
        context.strokeRect(artBox.x, artBox.y, artBox.width, artBox.height);
        context.fillStyle = '#07285d';
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.font = '700 ' + Math.max(18, Math.round(canvasWidth / 42)) + 'px sans-serif';
        context.fillText((artworkNameProperty && artworkNameProperty.value) || 'Uploaded artwork', artBox.x + artBox.width / 2, artBox.y + artBox.height / 2, artBox.width * 0.82);
        context.restore();
      }

      var blob = await canvasBlob(canvas);
      return new File([blob], 'far-car-magnet-preview-' + Date.now() + '.png', { type: 'image/png', lastModified: Date.now() });
    }

    form.addEventListener('submit', function (event) {
      if (previewPrepared) { previewPrepared = false; return; }
      if (previewPreparing || !artworkReady) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      previewPreparing = true;
      if (submitButton) submitButton.disabled = true;
      if (formStatus) { formStatus.textContent = 'Preparing your cart preview…'; formStatus.classList.remove('is-error'); }
      generateCartPreview()
        .then(function (file) {
          assignPreviewFile(file);
          previewPrepared = true;
          previewPreparing = false;
          if (formStatus) formStatus.textContent = 'Preview attached. Adding to cart…';
          if (typeof form.requestSubmit === 'function') form.requestSubmit(submitButton || undefined);
          else HTMLFormElement.prototype.submit.call(form);
        })
        .catch(function (error) {
          previewPreparing = false;
          if (submitButton) submitButton.disabled = false;
          if (formStatus) { formStatus.textContent = error && error.message ? error.message : 'The cart preview could not be prepared.'; formStatus.classList.add('is-error'); }
        });
    }, true);

    function beginMove(event) {
      if (event.target && event.target.closest('[data-far-car-v4-resize-handle]')) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      interaction = { type: 'move', pointerId: event.pointerId, startX: event.clientX, startY: event.clientY, x: state.x, y: state.y };
      magnet.classList.add('is-dragging');
      if (magnet.setPointerCapture) magnet.setPointerCapture(event.pointerId);
      event.preventDefault();
    }
    function beginResize(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      event.stopPropagation();
      var rect = magnet.getBoundingClientRect();
      var cx = rect.left + rect.width / 2, cy = rect.top + rect.height / 2;
      interaction = { type: 'resize', pointerId: event.pointerId, startDistance: Math.max(12, Math.hypot(event.clientX - cx, event.clientY - cy)), startScale: state.scale, cx: cx, cy: cy, target: event.currentTarget };
      magnet.classList.add('is-resizing');
      if (event.currentTarget.setPointerCapture) event.currentTarget.setPointerCapture(event.pointerId);
      event.preventDefault();
    }
    function moveInteraction(event) {
      if (!interaction || event.pointerId !== interaction.pointerId || !editor) return;
      if (interaction.type === 'move') {
        var rect = editor.getBoundingClientRect();
        state.x = interaction.x + ((event.clientX - interaction.startX) / rect.width) * 100;
        state.y = interaction.y + ((event.clientY - interaction.startY) / rect.height) * 100;
        applyPosition();
      } else {
        var distance = Math.max(12, Math.hypot(event.clientX - interaction.cx, event.clientY - interaction.cy));
        state.scale = clamp(interaction.startScale * (distance / interaction.startDistance), 35, 240);
        applyGeometry();
      }
    }
    function endInteraction(event) {
      if (!interaction || event.pointerId !== interaction.pointerId) return;
      magnet.classList.remove('is-dragging', 'is-resizing');
      var target = interaction.target || magnet;
      if (target.releasePointerCapture && target.hasPointerCapture && target.hasPointerCapture(event.pointerId)) target.releasePointerCapture(event.pointerId);
      interaction = null;
    }

    if (magnet) {
      magnet.addEventListener('pointerdown', beginMove);
      magnet.addEventListener('keydown', function (event) {
        var increment = event.shiftKey ? 5 : 1;
        if (event.key === 'ArrowLeft') state.x -= increment;
        else if (event.key === 'ArrowRight') state.x += increment;
        else if (event.key === 'ArrowUp') state.y -= increment;
        else if (event.key === 'ArrowDown') state.y += increment;
        else if (event.key === '+' || event.key === '=') { setScale(state.scale + 5); event.preventDefault(); return; }
        else if (event.key === '-' || event.key === '_') { setScale(state.scale - 5); event.preventDefault(); return; }
        else return;
        applyPosition(); event.preventDefault();
      });
    }
    root.querySelectorAll('[data-far-car-v4-resize-handle]').forEach(function (handle) {
      handle.addEventListener('pointerdown', beginResize);
      handle.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight' || event.key === 'ArrowUp' || event.key === '+' || event.key === '=') { setScale(state.scale + 5); event.preventDefault(); }
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown' || event.key === '-' || event.key === '_') { setScale(state.scale - 5); event.preventDefault(); }
      });
    });

    var eventDocument = root.ownerDocument || document;
    eventDocument.addEventListener('pointermove', moveInteraction);
    eventDocument.addEventListener('pointerup', endInteraction);
    eventDocument.addEventListener('pointercancel', endInteraction);
    if (scaleInput) scaleInput.addEventListener('input', function () { setScale(scaleInput.value); });
    if (centerButton) centerButton.addEventListener('click', function () { scheduleCenter(false); });
    if (resetButton) resetButton.addEventListener('click', function () { scheduleCenter(true); });
    root.querySelectorAll('[data-far-car-v4-option]').forEach(function (input) { input.addEventListener('change', updateVariant); });
    root.querySelectorAll('[data-far-car-v4-option-select]').forEach(function (select) { select.addEventListener('change', updateVariant); });
    sceneChoices.forEach(function (choice) { choice.addEventListener('change', function () { if (choice.checked) applyScene(choice.value, true); }); });
    if (artworkInput) artworkInput.addEventListener('change', function () { loadArtwork(artworkInput.files && artworkInput.files[0]); });
    if (customVehicleInput) customVehicleInput.addEventListener('change', function () { loadCustomVehiclePhoto(customVehicleInput.files && customVehicleInput.files[0]); });

    function enableDropzone(dropzone, input, loader) {
      if (!dropzone || !input || typeof DataTransfer === 'undefined') return;
      ['dragenter', 'dragover'].forEach(function (name) { dropzone.addEventListener(name, function (event) { event.preventDefault(); dropzone.classList.add('is-dragging'); }); });
      ['dragleave', 'drop'].forEach(function (name) { dropzone.addEventListener(name, function (event) { event.preventDefault(); dropzone.classList.remove('is-dragging'); }); });
      dropzone.addEventListener('drop', function (event) {
        var file = event.dataTransfer && event.dataTransfer.files ? event.dataTransfer.files[0] : null;
        if (!file) return;
        var transfer = new DataTransfer(); transfer.items.add(file); input.files = transfer.files; loader(file);
      });
    }
    enableDropzone(root.querySelector('[data-far-car-v4-dropzone]'), artworkInput, loadArtwork);
    enableDropzone(root.querySelector('[data-far-car-v4-vehicle-dropzone]'), customVehicleInput, loadCustomVehiclePhoto);
    window.addEventListener('resize', function () { window.requestAnimationFrame(applyGeometry); });

    updateSizeSwatches();
    applyScene('van-side', true);
    if (artworkReady) loadArtwork(artworkInput.files[0]);
    if (vehicleReady) loadCustomVehiclePhoto(customVehicleInput.files[0]);
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-far-car-v4]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();